import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ResponseRegions } from "src/app/models/shared/response-regions";
import { RecommendationService } from "src/app/services/recommendation/recommendation.service";

@Injectable()
export class RegionResolver implements Resolve<Observable<ResponseRegions>> {

    constructor(private recommendationService: RecommendationService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<ResponseRegions>> {
        const response = this.recommendationService.getRegions()
            .pipe(map(response => {
                if (response.success) {
                    return response.payload;
                }
                else {
                    return <ResponseRegions>{
                        options: [],
                        defaultOption: null,
                        lockRegion: false
                    };
                }
            }));
        const responsePromise = new Promise<Observable<ResponseRegions>>((resolve, reject) => { resolve(response) });
        return responsePromise;
    }

}